module.exports = __webpack_public_path__ + "e692aeabadeef71771a75cea746df2d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-parvulo-home.png
// module id = 109
// module chunks = 0